import { Outlet } from 'react-router-dom'

export const PublicLayout = () => {
  return <Outlet />
}
